/** These are all the fields that can be used to filter a user search. */
export const standardFilterFields = [
	'id',
	//
	'countryCodes',
	'franchiseIds',
	'organizationIds',
	'principalIds',
	'clientIds',
	'customerIds',
	//
	'team',
	//
	'userGroup',
	//
	'status',
	'skills',
] as const;

export const booleanFilterFields = ['canAccessPlatform'] as const;

export const filterFields = [...standardFilterFields, ...booleanFilterFields] as const;

/** These are the fields that are used by the user list. */
export const listFilterFields = [
	'countryCodes',
	'franchiseIds',
	'organizationIds',
	'principalIds',
	'clientIds',
	'customerIds',
] as const;

// oxlint-disable-next-line no-unused-vars
type _ListFilterFieldsSafetyNet<
	T extends (typeof filterFields)[number] = (typeof listFilterFields)[number],
> = T;

/** These are the fields that are used by the admin user search. */
export const adminFilterFields = ['clientIds', 'team', 'userGroup'] as const;

// oxlint-disable-next-line no-unused-vars
type _AdminFilterFieldsSafetyNet<
	T extends (typeof filterFields)[number] = (typeof adminFilterFields)[number],
> = T;

export const adminFilterBooleanFields = ['canAccessPlatform'] as const;

// oxlint-disable-next-line no-unused-vars
type _adminFilterBooleanFieldsSafetyNet<
	T extends (typeof filterFields)[number] = (typeof adminFilterBooleanFields)[number],
> = T;

/** These are the fields that are used by the estimator user search. */
export const estimatorFilterFields = ['id', 'team', 'status', 'skills', 'userGroup'] as const;

// oxlint-disable-next-line no-unused-vars
type _EstimatorFilterFieldsSafetyNet<
	T extends (typeof filterFields)[number] = (typeof estimatorFilterFields)[number],
> = T;
